import { UserDetailsService } from './../profile-settings/user-details.service';
import { UserDataService } from '@services/data-services/user-data.service';
import { Inject, Injectable } from '@angular/core';
import { ValidateEmailService } from './validate-email.service';
import { CreateUserMongoService } from './create-user-mongo.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_iam/authentication-service.service';
import { environment } from '@env/environment';
import { StorageServiceObservablesService } from '../storage-service-observables/storage-service-observables.service';
import { DOCUMENT } from '@angular/common';
import { ClientCredentialsService } from '@services/client-credentials/client-credentials.service';
import { HttpClient } from '@angular/common/http';
import { AuthStateService } from '@mapfre-design-library/src/lib/_services/auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class UpdatePasswordService {
  expireInDays = 365;

  constructor(
    private validateEmailService: ValidateEmailService,
    private createUserMongoService: CreateUserMongoService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private storageServiceObservable: StorageServiceObservablesService,
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private clientCredentialsService: ClientCredentialsService,
    private userDataService: UserDataService,
    private authStateService: AuthStateService
  ) { }

  checkLoginCount(email, count, flag) {
    /**
     * If flag = true, we are setting count value
     * If flag = false, we are retrieving count value
     */
    this.authenticationService
      .checkLoginCount(email, count, flag)
      .subscribe((data) => {
        const loginCount = data;
        if (loginCount != null) {
          localStorage.setItem('loginCount', loginCount.toString());
          if (loginCount.toString() === '1') {
            localStorage.setItem('isFirstimeLogin', 'true');
          }
        }
      });
  }
  submitForm(mapForm) {
    const map = window.open('', '_self');
    if (map) {
      mapForm.submit();
    } else {
      alert('Please turn off the popup blocker');
    }
    document.body.removeChild(mapForm);
  }

  redirectLegacyDashboard1(token) {
    this.document.location.href = `${environment.legacy_login}` + token;
  }

  redirectLegacyDashboard(token): void {
    const url = `${environment.legacy_login}`;
    const mapForm = document.createElement('form');
    mapForm.setAttribute('style', 'display: none');
    mapForm.target = '_self';
    mapForm.method = 'POST';
    mapForm.action = url;

    const mapInput = document.createElement('input');
    mapInput.setAttribute('type', 'text');
    mapInput.setAttribute('name', 'userAuthToken');
    mapInput.setAttribute('value', token);
    mapForm.appendChild(mapInput);
    document.body.appendChild(mapForm);
    this.submitForm(mapForm);
  }
  setCookieAndRouteToDashboard(email, remember, bioMetric?): void {
    //this.router.navigate([`/home`]);
    this.putCookie(email, remember, bioMetric);
  }

  async createLocalStorageUser(accessToken, email?, password?, remember?, bioMetric?) {

    await this.clientCredentialsService.getToken().subscribe((token) => {
      // token.access_token
      // const token = JSON.parse(accessToken);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      user.access_token = token;
      localStorage.setItem('currentUser', JSON.stringify(user));
      
       // Signal that the auth token is now available for API calls
      this.authStateService.notifyTokenReady();

      if (typeof window !== 'undefined' && (window as any).dtrum
        && typeof (window as any).dtrum.identifyUser === 'function' && user?.username) {
        (window as any).dtrum.identifyUser(user.username);
        }
        
      this.validateEmailService
        .checkActiveEmail(user.username)
        .subscribe(
          (customerData: any) => {
            const { daysSinceLastLogin, daysSinceLastSnooze, customer } = customerData;
            localStorage.setItem(
              'cpModalsnoozeSince',
              JSON.stringify({ daysSinceLastLogin, daysSinceLastSnooze })
            );
            // localStorage.setItem('currentUser', accessToken);
            // Only persist the minimal fields actually consumed from storage
            // (firstName/lastName/email) instead of the full customer profile,
            // which may include billing/policy/PII data.
            const minimalAccountHolder = {
              firstName: customer?.firstName,
              lastName: customer?.lastName,
              email: customer?.email,
            };
            localStorage.setItem('accountHolder', JSON.stringify(minimalAccountHolder));
            this.userDataService.updateCustomerData(customer);
            this.setCookieAndRouteToDashboard(email, remember, bioMetric);
          },
          (err) => {
            if (err.status === 404) {
              // localStorage.setItem('currentUser', accessToken);
              this.createUserMongoService
                .createMongoUser(email, password)
                .subscribe(
                  () =>
                    this.setCookieAndRouteToDashboard(email, remember, bioMetric),
                );
            }
          }
        );
    })


  }

  putCookie(email, remember, bioMetric): void {
    if (remember) {
      this.userDetailsService.getUserForCookie().subscribe((responseName) => {
        this.storageServiceObservable.deleteCookie();
        this.storageServiceObservable.setCookie(
          email,
          responseName,
          remember,
          bioMetric
        );
      });
    } else {
      this.storageServiceObservable.deleteCookie();
    }
  }
}

